import numeral from 'numeral'
import moment from 'moment'
import 'numeral/locales/de'
import camelCase from 'lodash/camelCase'
import take from 'lodash/take'
// const URL_REGEX = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi

window.moment = moment

numeral.locale('de')

// export function urlsToLinks(text) {
//   if(!text) { return text }
//   const matches = text.match(URL_REGEX)
//   if(!matches) { return text }

//   let ret = text
//   matches.forEach(match => 
//     ret = ret.replace(match, `<a href="${match}" target="_blank">${match}</a>`)
//   )
//   return ret
// }

export function getPlayerPath(player) {
  return `/players/${player.id}`
}

export function getTicketPath(ticket) {
  return `/players/${ticket.player_id}/tickets/${ticket.id}`
}

export function getProjectPath(project) {
  return `/projects/${project.model_id}`
}

export function getDateRange(date) {
  const TIME_WINDOW = 3
  const afterDate = moment(date).utc().subtract(TIME_WINDOW, 'hours')
  const beforeDate = moment(date).utc().add(TIME_WINDOW, 'hours')

  return { afterDate, beforeDate }
}

export function getRecommendationsPath(playerId, date) {
  return `${getPlayerPath({id: playerId})}/recommendations/?date=${moment.utc(date).toISOString()}`
}

export function getRecommenderPath(playerId) {
  return `${getPlayerPath({id: playerId})}/recommender`
}

export function formatMoney(amount) {
  return numeral(amount, 'EUR').format('(0,0.00)$')
}

export function getSort(ordering) {
  let sortDirection, sortBy = ''
  if(!ordering) { return {sortDirection, sortBy} }

  if(ordering[0] === '-') {
    sortDirection = 'DESC'
    sortBy = camelCase(ordering.slice(1))
  } else {
    sortDirection = 'ASC'
    sortBy = camelCase(ordering)
  }

  return {sortDirection, sortBy}
}

export function getParticipantsString(event) {
  if(!event) { return '' }
  return take(event.participants, 4).map(participant => participant.split('@')[0]).join(' - ')
}


// WEBPACK FOOTER //
// ./src/util.js